import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CalAngularService } from '@cvx/cal-angular';
import { environment } from '../environments/environment';

const scope = environment.scope;

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(CalAngularService);

  const getToken = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      authService.getAADToken([scope]).subscribe(
        (data) => {
          if (data) {
            resolve(data.toString());
          } else {
            reject('No token found');
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  };

  return from(getToken()).pipe(
    switchMap((token) => {
      if (token) {
        const cloned = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
        return next(cloned);
      } else {
        return next(req);
      }
    })
  );
};
